import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from '../apiSlice'
import { IBadgeDataToBack, IGetBadges, IGetBadgesData } from './model'
import { formDataCreate } from '../../../utils/formDataUpload/formDataUpload'
import { ISearchParams } from '../../../global.model'

export const badgesApi = createApi({
  reducerPath: 'badges/api',
  baseQuery: baseQueryWithReauth,
  endpoints: build => ({
    getBadges: build.query<IGetBadges, ISearchParams | void>({
      query: params => ({
        url: '/admin/badge',
        method: 'GET',
        params: { ...params }
      })
    }),
    getBadgeById: build.query<IGetBadgesData, string>({
      query: (badgeId: string) => ({
        url: `admin/badge/${badgeId}`,
        method: 'GET'
      })
    }),
    createBadge: build.mutation<void, IBadgeDataToBack>({
      query: (createData: IBadgeDataToBack) => ({
        url: '/admin/badge',
        method: 'POST',
        body: formDataCreate({ ...createData })
      })
    }),
    updateBadge: build.mutation<void, IBadgeDataToBack>({
      query: (updateData: IBadgeDataToBack) => ({
        url: '/admin/badge/update',
        method: 'PUT',
        body: formDataCreate({ ...updateData })
      })
    }),
    deleteBadge: build.mutation<void, string>({
      query: (badgeId: string) => ({
        url: `admin/badge/${badgeId}`,
        method: 'DELETE'
      })
    })
  })
})
export const {
  useGetBadgesQuery,
  useGetBadgeByIdQuery,
  useCreateBadgeMutation,
  useUpdateBadgeMutation,
  useDeleteBadgeMutation
} = badgesApi
